import { render } from "./NewAsideExternalDevice.vue?vue&type=template&id=02131fdc&scoped=true"
import script from "./NewAsideExternalDevice.vue?vue&type=script&lang=js"
export * from "./NewAsideExternalDevice.vue?vue&type=script&lang=js"

import "./NewAsideExternalDevice.vue?vue&type=style&index=0&id=02131fdc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02131fdc"]])

export default __exports__